export default "__VITE_ASSET__XoBLlwVxWssXQ4yvOiLBjg__"